function escapeRustString(str) {
  return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\0/g, "\\0");
}
function toRustString(str) {
  return `"${escapeRustString(str)}"`;
}
export {
  toRustString
};
//# sourceMappingURL=rustString.js.map
